import {connect} from 'react-redux';

import {removeCardGroupFromCardsAsyncAction} from '../../../../../../../../../../src/store/data/cardGroups/cardGroupsActions';
import {contactsManagerTableRemoveCardIdRefsAction} from '../../../../../../../../../../src/store/panels/contacts/contactsManager/table/contactsManagerTableActions';
import {ContactsManagerPanelId} from '../../../../../../../../../../src/store/panels/panelStateBase';
import {makeMapDispatchToProps} from '../../../../../../../../../../srcCommon/helpers/reselectHelpers';
import {ContactsTableMultiRemoveFromListAction} from './contactsTableMultiRemoveFromListAction';

/*
 * Props.
 */

interface ContactsTableMultiRemoveFromListActionContainerProps {
  panelId: ContactsManagerPanelId;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<ContactsTableMultiRemoveFromListActionContainerProps>()(
  ({panelId}) => ({
    onRemoveSuccess: (cardIds: ReadonlyArray<number>) =>
      contactsManagerTableRemoveCardIdRefsAction(panelId, cardIds),
    onRemoveCardsFromCardGroupsAsync: removeCardGroupFromCardsAsyncAction,
  }),
);

export const ContactsTableMultiRemoveFromListActionContainer = connect(
  null,
  mapDispatchToProps,
)(ContactsTableMultiRemoveFromListAction);
